var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","content-class":"tooltip","max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mr-4"},on),[_vm._v(" mdi-help-circle-outline ")])]}}])},[_vm._v(" "+_vm._s(_vm.hint)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }